module.exports = __webpack_public_path__ + "img/a40254d.jpg";